import { useState } from 'react';
import Box from '@mui/material/Box';
import Input from 'components/system/Input';
import Button from '@mui/material/Button';
import InputAdornment from '@mui/material/InputAdornment';
import SearchIcon from '@mui/icons-material/Search';
import ClearIcon from '@mui/icons-material/Clear';
import colors from 'styles/colors';
import StatusMultiSelect from './StatusMultiSelect';

const STATUS_FILTER = 'status';

const JobsCommonFilters = ({
  filters, onFilterChange, handleSearch, searchQuery: externalSearchQuery,
}) => {
  const [localSearchQuery, setLocalSearchQuery] = useState(externalSearchQuery || '');
  const handleResetSearch = () => {
    setLocalSearchQuery('');
    handleSearch('');
  };

  return (
    <Box sx={{
      padding: '0 0 16px 0', display: 'flex', gap: '4px', flexWrap: 'wrap',
    }}
    >
      {/* Filters row */}
      <Box sx={{
        display: 'flex', gap: '10px', alignItems: 'flex-start', width: '100%',
      }}
      >

        {/* Search filter */}
        <Box sx={{
          display: 'flex', width: '350px', minWidth: '300px',
        }}
        >
          <Input
            value={localSearchQuery}
            onChange={(e) => {
              setLocalSearchQuery(e.currentTarget.value);
            }}
            placeholder="Search by job name"
            sx={{
              width: '100%',
              marginRight: '10px',
              flex: 1,
              '.MuiOutlinedInput-root': {
                fontSize: '12px !important',
              },
              '.MuiOutlinedInput-notchedOutline': {
                borderRadius: '8px',
              },
              '.MuiOutlinedInput-root input::placeholder': {
                fontSize: '14px',
                fontWeight: '400',
                opacity: 1,
                color: colors.text.tetriary,
              },
            }}
            onKeyDown={(e) => {
              if (e.key === 'Enter') {
                handleSearch(localSearchQuery);
              }
            }}
            endAdornment={(
              localSearchQuery && (
                <InputAdornment position="end">
                  <ClearIcon
                    onClick={handleResetSearch}
                    fontSize="small"
                    sx={{ color: colors.text.primary, cursor: 'pointer' }}
                  />
                </InputAdornment>
              )
            )}
            startAdornment={(
              <InputAdornment position="start">
                <SearchIcon
                  fontSize="small"
                  sx={{ color: colors.text.secondary }}
                />
              </InputAdornment>
            )}
          />
          <Button
            variant="outlined"
            type="button"
            color="secondary"
            sx={{
              minWidth: '40px',
              borderRadius: '8px',
              border: `1px solid ${colors.border.border_10p}`,
              color: colors.text.secondary,
              fontWeight: '400',
              ':hover': {
                border: `1px solid ${colors.text.primary}`,
                color: colors.text.primary,
                backgroundColor: colors.text.qaterniary,
              },
            }}
            onClick={() => handleSearch(localSearchQuery)}
          >
            Search
          </Button>
        </Box>
        {/* Status filter */}
        <Box sx={{
          display: 'flex', flexDirection: 'column', gap: '8px', width: '300px',
        }}
        >
          <StatusMultiSelect
            selectedStatuses={filters.runStatus}
            onChange={(selectedValues) => onFilterChange(STATUS_FILTER, selectedValues)}
          />
        </Box>
      </Box>
    </Box>
  );
};

export default JobsCommonFilters;
